"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var MasterContext = react_1.createContext({
    selectedItem: undefined,
    handleSubmit: function (_) { },
});
exports.default = MasterContext;
